import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { ActionDoneIndicator } from "../action-done-indicator";
/** Read-only view of a completed task action showing a "Created" status marker. */
export function TaskActionSummary(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 px-4 py-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 min-w-0 flex-col gap-0.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small-strong line-through text-sds-base-secondary truncate"
  }, title), subtitle && /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary truncate"
  }, subtitle)), /*#__PURE__*/React.createElement(ActionDoneIndicator, {
    label: t("status.created", {
      defaultValue: "Created"
    })
  }));
}